/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_New_Password_CrumbInputs */

const en_auth_new_password_crumb = /** @type {(inputs: Auth_New_Password_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const pl_auth_new_password_crumb = /** @type {(inputs: Auth_New_Password_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe hasło`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {Auth_New_Password_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_new_password_crumb = /** @type {((inputs?: Auth_New_Password_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_New_Password_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_new_password_crumb(inputs)
	return en_auth_new_password_crumb(inputs)
});